import { SVGProps } from 'react';

const GitPullRequestDraft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v12M18 6V5m0 6v-1m3 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default GitPullRequestDraft;
